import InputMask from 'react-input-mask'
import { TextField } from '@mui/material'

const PhoneNumberTextField = (props: { value: string; onChange?: any }) => {
	return (
		<div>
			<InputMask
				onChange={props.onChange}
				mask='+7 (999) 999-99-99'
				value={props.value}
			>
				<TextField
					InputLabelProps={{
						shrink: true,
					}}
					required
					label='Номер телефона'
					fullWidth
					name='phone_number'
					error={props.value?.replaceAll(/\D/g, '').length < 11}
				/>
			</InputMask>
		</div>
	)
}

export default PhoneNumberTextField
